<div class="flex-1 flex flex-col overflow-hidden">
  <app-map
    [type]="'grower'"
    class="flex-grow overflow-hidden"
    [fields]="fields"
    [isUpdateZoomLevel]="isUpdateZoomLevel"
    [clients]="clients"
    [(selectedClientId)]="clientId"
    (featureProperties)="selectUpdateModalShow($event)"
  />
</div>
<app-field-selection-update
  (fieldOperatedEvent)="onCreateUpdateCropRecords($event)"
  [id]="properties?.id"
  [client_name]="properties?.client_name"
  [owner]="properties?.owner"
  [crops]="crops"
  [cropsNoFallow]="cropsNoFallow"
/>
